<template>
  <div class="main">
    <!-- 首页轮播 -->
    <div>
      <div class="lunbo" v-if="false && banners.length > 0">
        <!-- :height="bannerHeight + 'px'" -->
        <el-carousel trigger="click">
          <el-carousel-item v-for="(item, index) in banners" :key="index">
            <div class="bannerContent">
              <el-image style="width: 100%;" :src="item.image" fit="contain">
              </el-image>
              <div class="bannerBtns" v-if="item.button">
                <div class="tagLine fontPB hv">{{ item.tag_line }}!</div>
                <div
                  class="tagBtn fontPM hv"
                  @click="toLink(item.button.data[0].link)"
                >
                  {{ item.button.data[0].name }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <img :src="require('@/assets/img/home/home_banner_mobile.jpg')" class="hidden-lg-and-up" style="width: 100%"/>
      <img :src="require('@/assets/img/home/home_banner.jpg')" class="hidden-md-and-down" style="width: 100%"/>
      <HomeSloganBar :style="{ backgroundColor: bgcolor }"/>
      <!-- <div style="max-width:1500px;margin: 0 auto"> -->

      <ProductList :products="products"/>
      <!-- <ProductLine></ProductLine> -->
      <ToysCollection/>
      <!-- <ArFunction title="AR Function"></ArFunction> -->
      <!-- <ArFunction title="Toys Collection"/>-->
      <!-- <DetailVr :imgShow="imgShow"></DetailVr> -->
      <div class="why fontPB">
        <div class="pink">
          <div class="pinkTitle">
            <div>{{ $t('index.why') }}</div>
          </div>
        </div>

        <div class="workContent">
          <div class="workItem">
            <el-image
              class="workImg"
              :src="require('@/assets/img/why1.jpg')"
              fit="contain"
            ></el-image>
            <div class="workTitle">{{ $t('index.whytitle1') }}</div>
            <div class="workText fontPR">{{ $t('index.whyinfo1') }}</div>
          </div>
          <div class="workItem">
            <el-image
              class="workImg"
              :src="require('@/assets/img/why2.jpg')"
              fit="contain"
            ></el-image>
            <div class="workTitle">{{ $t('index.whytitle2') }}</div>
            <div class="workText fontPR">{{ $t('index.whyinfo2') }}</div>
          </div>
          <div class="workItem">
            <el-image
              class="workImg"
              :src="require('@/assets/img/why3.jpg')"
              fit="contain"
            ></el-image>
            <div class="workTitle">{{ $t('index.whytitle3') }}</div>
            <div class="workText fontPR">{{ $t('index.whyinfo3') }}</div>
          </div>
        </div>

        <div class="whyContent">
          <div class="whyItem">
            <div class="whyText">{{ $t('index.review1') }}</div>
            <div class="whyStar">
              <div>{{ $t('index.reviewname1') }}</div>
              <div class="fontPL" style="color: #4b4b4b">
                <i class="el-icon-star-on" style="color: #ffc80b"></i>4.7
              </div>
            </div>
          </div>
          <div class="whyItem">
            <div class="whyText">{{ $t('index.review2') }}</div>
            <div class="whyStar">
              <div>{{ $t('index.reviewname2') }}</div>
              <div class="fontPL" style="color: #4b4b4b">
                <i class="el-icon-star-on" style="color: #ffc80b"></i>5
              </div>
            </div>
          </div>
          <div class="whyItem">
            <div class="whyText">{{ $t('index.review3') }}</div>
            <div class="whyStar">
              <div>{{ $t('index.reviewname3') }}</div>
              <div class="fontPL" style="color: #4b4b4b">
                <i class="el-icon-star-on" style="color: #ffc80b"></i>4.8
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <el-dialog :visible.sync="homepopup">
      <div class="dialog">
        <i class="el-icon-error" @click="homepopup = false"></i>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import HomeSloganBar from '@/common/HomeSloganBar.vue';
import DetailVr from '@/common/DetailVr.vue';
import ProductLine from '@/common/ProductLine.vue';
import ProductList from '@/common/ProductList.vue';
import ToysCollection from '@/common/ToysCollection.vue';
import ArFunction from '@/common/ArFunction.vue';

export default {
  components: {
    HomeSloganBar,
    DetailVr,
    ProductLine,
    ProductList,
    ToysCollection,
    ArFunction,
  },
  data () {
    // const homepopup = !!document.cookie.split(';').find(x => x.trim().split('=')[0] === 'homepopup');
    return {
      bgcolor: '#00000040',
      imgShow: true,
      bannerHeight: 400,
      banners: [],
      products: [],
      homepopup: true,
    };
  },
  watch: {
    banners: function () {
      this.$nextTick(function () {
        /*现在数据已经渲染完毕*/
        var self = this;
        self.getImgHeight();
      });
    },
  },
  mounted () {
    this.getProducts();
    this.getBanners();
    let that = this;
    window.addEventListener('resize', () => {
      that.getImgHeight();
    });
    this.getPageContent();
    // "Authorization": this.$localStorage.token_type+this.$localStorage.token
    if (this.$route.query.token) {
      this.$localStorage.setItem('token', this.$route.query.token);
      this.$localStorage.setItem('token_type', 'Bearer');
      this.$store.commit('setToken', this.$route.query.token);
      this.$store.commit('setTokenType', 'Bearer');
      this.getUserInfo();
    }
    setTimeout(() => {
      this.homepopup = false;
    }, 5000);
  },
  methods: {
    async getProducts () {
      this.products = await Promise.all(
        [121, 114, 125, 100].map(id => this.$axios.get(`/api/products/${id}`)),
      );
    },
    getUserInfo () {
      this.$axios({
        method: 'get',
        url: '/api/user',
        headers: {
          Authorization: 'Bearer ' + this.$localStorage.token,
        },
      }).then((res) => {
        // console.log(res);
        this.$store.commit('setUserId', res.id);
        this.$store.commit('setUserName', res.name);
        this.$store.commit('setUserEmail', res.email);
        this.$store.commit('setNewsletter', res.is_newsletter);
        this.$store.commit('setLanguage', res.language);
      });
    },
    getImgHeight () {
      var w = document.documentElement.clientWidth || document.body.clientWidth;
      // console.log(
      //   $(".bannerContent .el-image img").width() +
      //     "   " +
      //     $(".bannerContent .el-image img").height()
      // );
      this.bannerHeight = (w / 1400) * 400;
      // console.log(this.bannerHeight);
    },
    getBanners () {
      this.$axios({
        method: 'get',
        url: '/api/banners?include=button',
      }).then((res) => {
        // console.log(res);
        this.banners = res.data;
      }).catch((error) => {});
    },
    getPageContent () {
      this.$axios({
        method: 'post',
        url: '/api/page',
        data: {
          page_id: 25,
        },
      }).then((res) => {
        console.log(res);
      }).catch((error) => {});
    },
    toLink (link) {
      window.open(link);
    },
  },
};
</script>
<style scoped>
.el-icon-error {
  font-size : 60px;
  float     : right;
  padding   : 10px;
  cursor    : pointer;
  color     : white;
  opacity   : 0.75;
}

/deep/ .el-dialog__wrapper {
  display         : flex;
  justify-content : center;
  align-items     : center;
}

/deep/ .el-dialog {
  background    : transparent;
  border-radius : 0;
  box-shadow    : none;
}

/deep/ .el-dialog__header {
  display : none;
}

.dialog {
  /* todo: popup banner */
  background-image    : url('~@/assets/img/popup_banner.jpg');
  background-size     : contain;
  background-repeat   : no-repeat;
  background-position : center;
  padding-bottom      : 67%;
}

.lunbo {
  margin : 0;
  height : 550px;
}

/deep/ .el-carousel {
  height : 100%;
}

/deep/ .el-carousel__container {
  height : 100%;
}

/deep/ .el-carousel__button {
  width         : 10px;
  height        : 10px;
  border-radius : 50%;
}

/deep/ .el-carousel__arrow {
  width     : 50px;
  height    : 50px;
  font-size : 25px;
}

.main {
  width  : 100%;
  height : auto;
}

.bannerContent {
  width    : 100%;
  height   : 100%;
  position : relative;
}

.bannerBtns {
  position   : absolute;
  bottom     : 20%;
  left       : 20%;
  z-index    : 2;
  text-align : left;
}

.tagLine {
  height      : 80px;
  line-height : 80px;
  font-size   : 50px;
  color       : #fff;
}

.tagBtn {
  display       : inline-block;
  width         : 250px;
  height        : 60px;
  line-height   : 60px;
  color         : #fff;
  margin-right  : 8px;
  background    : rgb(154, 216, 218);
  border-radius : 40px;
  text-align    : center;
  font-size     : 40px;
  border        : none;
  outline       : none;
}

/*why people*/
.why {
  width         : 100%;
  position      : relative;
  margin-bottom : 20px;
}

.pink {
  width      : 100%;
  height     : 300px;
  background : #ddaba0;
}

.pinkTitle {
  width : 100%;
  color : #fff;
}

.pinkTitle > div:first-child {
  height      : calc(100vw / 1920 * 150);
  line-height : calc(100vw / 1920 * 150);
  font-size   : 50px;
  text-align  : center;
}

.workContent {
  display         : flex;
  justify-content : space-around;
  margin-top      : -150px;
}

.workItem {
  width      : 30%;
  text-align : center;
  color      : #7b5c55;
}

.workImg {
  width            : 50%;
  height           : auto;
  border-radius    : 50%;
  background-color : #fff;
}

.workTitle {
  height      : 50px;
  line-height : 50px;
  font-size   : 28px;
}

.workText {
  width         : 100%;
  height        : auto;
  line-height   : 20px;
  overflow      : hidden;
  font-size     : 16px;
  margin-bottom : 20px;
}

.whyContent {
  margin : 10px auto;
}

.whyItem {
  width            : 30%;
  height           : 100%;
  background-color : #fff;
  border           : 1px solid #e8e8e8;
  box-shadow       : 5px 10px 8px #e8e8e8;
  border-radius    : 10px;
}

.whyText {
  width       : 86%;
  margin-left : 7%;
  margin-top  : 50px;
  height      : 150px;
  font-size   : 24px;
  line-height : 30px;
  color       : #7b5c55;
}

.whyStar {
  width           : 86%;
  margin-left     : 7%;
  color           : #7b5c55;
  height          : 40px;
  line-height     : 40px;
  font-size       : 30px;
  display         : flex;
  justify-content : space-between;
}

.whyStar i {
  font-size : 40px;
}

/*手机*/
@media screen and (max-width : 768px) {
  /deep/ .el-dialog {
    width  : 300px;
    height : 300px;
  }

  .lunbo {
    height : 250px;
  }

  .promotion {
    flex-direction : column;
  }

  .promotion > div {
    font-size : 12px;
    padding   : 2px 0;
  }

  .bannerBtns {
    left   : 10%;
    bottom : 20%;
  }

  .tagLine {
    height      : 40px;
    line-height : 40px;
    font-size   : 20px;
  }

  .tagBtn {
    width       : 120px;
    height      : 34px;
    line-height : 34px;
    font-size   : 16px;
  }

  /*why people*/
  .why {
    width    : 100%;
    position : relative;
  }

  .whyItem {
    width          : 100%;
    height         : 160px;
    margin-bottom  : 10px;
    display        : flex;
    flex-direction : column;
  }

  .whyText {
    width       : 90%;
    margin-left : 5%;
    margin-top  : 20px;
    height      : 135px;
    font-size   : 14px;
  }

  .whyStar {
    width       : 86%;
    margin-left : 7%;
    color       : #7b5c55;
    height      : 35px;
    line-height : 35px;
    font-size   : 14px;
  }

  .whyStar i {
    font-size : 30px;
  }

  .whyContent {
    width  : 90%;
    margin : 0 auto;
    height : auto;
  }

  .pink {
    width      : 100%;
    height     : 200px;
    background : #ddaba0;
  }

  .pinkTitle {
    position    : relative;
    width       : 100%;
    height      : 60px;
    line-height : 60px;
    color       : #484848;
  }

  .pinkTitle > div:first-child {
    font-size   : 25px;
    line-height : 100px; /*padding:calc( 100vw / 1920 * 48) 0;*/
  }

  .workContent {
    width      : 90%;
    height     : auto;
    margin     : auto;
    display    : block;
    margin-top : -100px;
  }

  .title {
    width       : 100%;
    font-size   : 30px;
    color       : #484848;
    height      : 60px;
    line-height : 60px;
    padding-top : calc(100vw / 1920 * 50);
  }

  .workItem {
    width : 100%;
  }

  .workImg {
    width  : 40%;
    height : auto;
  }

  .workTitle {
    height      : 50px;
    line-height : 50px;
    font-size   : 22px;
  }

  .workText {
    font-size      : 14px;
    line-height    : 20px;
    padding-bottom : 20px;
    margin-bottom  : 0;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  /deep/ .el-dialog {
    width  : 400px;
    height : 400px;
  }

  .lunbo {
    height : 350px;
  }

  .promotion {
    flex-direction : column;
  }

  .promotion > div {
    font-size : 14px;
    padding   : 5px 0;
  }

  .bannerBtns {
    left   : 15%;
    bottom : 20%;
  }

  .tagLine {
    height      : 40px;
    line-height : 40px;
    font-size   : 24px;
  }

  .tagBtn {
    width       : 130px;
    height      : 40px;
    line-height : 40px;
    font-size   : 20px;
  }

  /*why people*/
  .why {
    width    : 100%;
    position : relative;
  }

  .whyContent {
    width           : 90%;
    margin          : 0 auto;
    height          : 220px;
    display         : flex;
    justify-content : space-around;
  }

  .whyItem {
    width  : 32%;
    height : 200px;
  }

  .pink {
    width      : 100%;
    height     : 220px;
    background : #ddaba0;
  }

  .pinkTitle {
    width : 100%;
    color : #fff;
  }

  .pinkTitle > div:first-child {
    font-size   : 42px;
    height      : calc(100vw / 1920 * 110);
    line-height : calc(100vw / 1920 * 110);
  }

  .workContent {
    width      : 90%;
    height     : auto;
    margin     : auto;
    margin-top : -110px;
    display    : flex;
  }

  .title {
    font-size   : 40px;
    height      : 80px;
    width       : 100%;
    padding-top : calc(100vw / 1920 * 50);
  }

  .workItem {
    width : 33%;
  }

  .workImg {
    width  : 40%;
    height : auto;
  }

  .workTitle {
    height      : 50px;
    line-height : 50px;
    font-size   : 24px;
  }

  .workText {
    font-size : 14px;
  }

  .whyText {
    margin-top : 20px;
    height     : 130px;
    font-size  : 18px;
  }

  .whyStar {
    font-size : 20px;
  }

  .whyStar i {
    font-size : 34px;
  }
}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  /deep/ .el-dialog {
    width  : 500px;
    height : 500px;
  }

  .lunbo {
    height : 450px;
  }

  .bannerBtns {
    left   : 20%;
    bottom : 20%;
  }

  .tagLine {
    height      : 60px;
    line-height : 60px;
    font-size   : 30px;
  }

  .tagBtn {
    width       : 160px;
    height      : 40px;
    line-height : 40px;
    font-size   : 24px;
  }

  /*why people*/
  .why {
    width    : 100%;
    position : relative;
  }

  .whyContent {
    width           : 90%;
    /*position: absolute;
            left: 5%;
            top: 125px;*/
    height          : 250px;
    display         : flex;
    justify-content : space-around;
  }

  .pink {
    width      : 100%;
    height     : 250px;
    background : #ddaba0;
  }

  .pinkTitle {
    width : 100%;
    color : #fff;
  }

  .pinkTitle > div:first-child {
    font-size   : 46px;
    height      : calc(100vw / 1920 * 125);
    line-height : calc(
      100vw / 1920 * 125
    ); /*padding:calc( 100vw / 1920 * 48) 0;*/
  }

  .whyText {
    margin-top : 40px;
    height     : 150px;
    font-size  : 21px;
  }

  .whyStar {
    font-size : 24px;
  }

  .whyStar i {
    font-size : 36px;
  }

  .workContent {
    width      : 90%;
    height     : auto;
    margin     : auto;
    margin-top : -125px;
  }

  .title {
    font-size   : 44px;
    height      : 80px;
    width       : 100%;
    padding-top : calc(100vw / 1920 * 50);
  }

  .workItem {
    width : 30%;
  }

  .workImg {
    width  : 45%;
    height : auto;
  }

  .workTitle {
    height      : 50px;
    line-height : 50px;
    font-size   : 26px;
  }

  .workText {
    font-size : 15px;
  }
}

/*大屏幕*/
@media screen and (min-width : 1200px) {
  .workContent {
    width      : 90%;
    max-width  : 1200px;
    height     : auto;
    margin     : auto;
    margin-top : -150px;
  }

  .whyContent {
    width           : 90%;
    /*position: absolute;
            left: 5%;
            top: 150px;*/
    margin          : 10px auto;
    height          : 300px;
    display         : flex;
    justify-content : space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue